import "./App.css";
//import "bootstrap/dist/css/bootstrap.min.css";
import React from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Home from "./pages/Home";
import Footer from "./pages/footer";
import Headers from "./pages/headers";
import Apropos from "./pages/apropos";
import Services from "./pages/services";
import Projets from "./pages/projets";
import Blogs from "./pages/blogs";
import Contacts from "./pages/contacts";
import BlogDetails from "./pages/blogDetails";
import ServicesDetails from "./pages/servicesDetails";
import Carrieres from "./pages/carrieres";
import Candidature from "./pages/candidature";
import ProjetDetails from "./pages/projetDetails";
function App() {
  return (
    <Router>
      <div>
        <Headers />
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/apropos" element={<Apropos />} />
          <Route path="/services" element={<Services />} />
          <Route path="/projets" element={<Projets />} />
          <Route path="/blogs" element={<Blogs />} />
          <Route path="/contacts" element={<Contacts />} />
          <Route path="/blogDetails/:id" element={<BlogDetails />} />
          <Route path="/servicesDetails/:id" element={<ServicesDetails />} />
          <Route path="/carrieres" element={<Carrieres />} />
          <Route path="/candidature" element={<Candidature />} />
          {/* <Route path="/projetDetails" element={<ProjetDetails/>} />  */}
          <Route path="/projets/:id" element={<ProjetDetails />} />

          {/* <Route path="/" element={<Home />} />
                   <Route path="/apropos" element={<Apropos />} />

                    <Route path="/courses" element={<Courses />} />
                    <Route path="/registration/:id" element={<Registration />} />
                    <Route path="/cours" element={<Cours />} />  
                    <Route path="/login" element={<Login />} /> 
                    <Route path="/CourseDetails/:id" element={<CourseDetails />} />
                    <Route path="/reservations/:id_formation/:id_groupe"element={<Reservations />} />
                    <Route path="/demandeFormation" element={<DemandeFormation />} />
                    <Route path="/certificateDetail/:id" element={<CertificateDetail />} /> */}
        </Routes>
        <Footer />
      </div>
    </Router>
  );
}

export default App;
